import { nanoid } from "nanoid/non-secure";
import { useMemo } from "react";

/**
 * Uses nanoid to create a unique id.
 */
export const createInputId = () => {
	return nanoid();
};

/**
 * Will generate a unique id or use the one provided. This is useful for
 * accessibility when using a label with an input.
 */
export const useInputId = (id?: string) => {
	const inputId = useMemo(() => {
		return id || createInputId();
	}, [id]);

	return inputId;
};
